module.exports = __webpack_public_path__ + "img/运营推广服务.349b430f.png";